import { serverUrl } from "../configs/server";
const origin = `${serverUrl}/discussion`
const commOrigin = `${ serverUrl}/community`

//create new discussion
export const newDiscussion = (data, token) => {
    return fetch(`${origin}/create`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        mode: 'cors'
    });
}

//load all discussions
export const loadDiscussions = () => {
    return fetch(`${origin}/all`, {
        method: "GET",
        mode: "cors"
    })
}

//get discussion by id
export const loadDiscussion = (id, token) => {
    return fetch(`${origin}/byId/${id}`, {
        method: "GET",
        headers: {
            'Authorization': `Bearer ${token}`
        },
        mode: "cors"
    })
}

//update a discussion
export const updateDiscussion = (data, id, token) => {
    return fetch(`${origin}/update/${id}`, {
        method: "PATCH",
        mode: 'cors',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
}

//comment on discussion
export const addComment = (data, token) => {
    return fetch(`${origin}/comment`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        mode: 'cors'
    })
}

//remove comment
export const removeComment = (id, token) => {
    return fetch(`${origin}/comment/${id}`, {
        method: "DELETE",
        headers: {
            'Authorization': `Bearer ${token}`
        },
        mode: 'cors'
    })
}

//reply to comment
export const addReply = (data, token) => {
    return fetch(`${origin}/replyto`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        mode: 'cors'
    })
}

//like discussion
export const toggleLike = (id, token) => {
    return fetch(`${origin}/like/${id}`, {
        method: "PUT",
        headers: {
            'Authorization': `Bearer ${token}`
        },
        mode: 'cors'
    })
}

//unlike discussion
export const toggleUnlike = (id, token) => {
    return fetch(`${origin}/unlike/${id}`, {
        method: "PUT",
        headers: {
            'Authorization': `Bearer ${token}`
        },
        mode: "cors"
    })
}

//delete a discussion
export const removeDiscussion = (token, id) => {
    return fetch(`${origin}/byId/${id}`, {
        method: "DELETE",
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
}

// community services

/**
 * create a new community
 * @param { object } data community json data
 * @param { string } token jwt access token
 * @returns promise
 */
export const createCommunity = (data, token) => {
    return fetch (`${commOrigin}/create`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    })
}

/**
 * update community data
 * @param {string} id {ObjectId} community _id
 * @param {string} token jwt access token
 * @returns promise
 */
export const updateCommunity = (id, token) => {
    return fetch (`${commOrigin}/update/${id}`, {
        method: "PATCH",
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
}




